import { AnyAction } from '@reduxjs/toolkit';
import { ForkEffect, put, takeEvery } from 'redux-saga/effects';

import { SailthruClient } from '../../../../data-sources/sailthru-client/SailthruClient';
import { createSignUpEmailCaptureErrorAction } from '../actions/sign-up-email-capture-error';
import { isSignUpEmailCaptureStartAction } from '../actions/sign-up-email-capture-start';
import { createSignUpEmailCaptureSuccessAction } from '../actions/sign-up-email-capture-success';
import { ErrorType } from '../email-capture.state';

export function* signUpEmailCaptureSaga (action: AnyAction): Iterator<any> {
    try {
        yield SailthruClient.signUpByEmail({
            email: action.payload,
            onError: function (): never {
                throw new Error(ErrorType.SAILTHRU);
            },
        });

        yield put(createSignUpEmailCaptureSuccessAction());
    } catch (error) {
        yield put(createSignUpEmailCaptureErrorAction());
    }
}

export function* watchSignUpEmailCapture (): Iterator<ForkEffect> {
    yield takeEvery(isSignUpEmailCaptureStartAction, signUpEmailCaptureSaga);
}
